import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/905314085858"
      target="_blank"
      rel="noopener noreferrer"
      className="
            fixed
            bottom-4
            right-4
            bg-green-500
            hover:bg-green-600
            text-white
            w-16
            h-16
            rounded-full
            shadow-lg
            flex
            items-center
            justify-center
            text-4xl
            z-50
            transition
          "
      title="WhatsApp ile iletişime geç"
    >
      <FaWhatsapp />
    </a>
  );
};

export default WhatsAppButton;
